import { useResponsive } from '../../../hooks/useResponsive';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';
import { useHeader } from './useHeader';

const Header = () => {
  const breakpointIndex = useResponsive([1024]);
  const props = useHeader();

  if (breakpointIndex === 0) {
    return <HeaderMobile {...props} />;
  }
  return <HeaderDesktop {...props} />;
};

export default Header;
